import NotFound from "pages/NotFound";
import { Admin, Eval, EvaluationDetail, Points } from "pages/Manager";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";

const Contant = () => {
  return (
    <Routes>
      <Route path={"/"} element={<PrivateRoute />}>
        <Route path={"/"} element={<Navigate replace to="admin" />} />
        <Route path={"admin"} element={<Admin />} />
        <Route path={"points"} element={<Points />} />
        <Route path={"eval"} element={<Eval />} />
        <Route path={"eval/:id"} element={<EvaluationDetail />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Contant;
